import moment from "../../moment";

export const getFrameAndIntervalFlag = (
  intervalLimit,
  masterSheet,
  used_frames,
  unused_frames
) => {
  console.log("getFrameAndIntervalFlag :>> start");

  var current = moment(new Date());

  let frame = null;
  let isInIntervalFlag = false;

  if (current.isAfter(intervalLimit)) {
    console.log("インターバル外なので次のフレームが使用可能");
    // インターバル外なので未使用のフレームの先頭のままでいいが、
    // is_fixed_frame== true ここでこの条件に当たる 1回券・10回券などですでに使い切ってしまっている(unused_frames.length==0)場合
    if (masterSheet.is_fixed_frame && unused_frames.length == 0) {
      console.log(
        "すでに全てのフレームを使ってしまっているので使用済みのフレームの先頭を指定"
      );
      frame = used_frames[0];
    } else {
      console.log("未使用のフレームの先頭を指定");
      frame = unused_frames[0];
    }
  } else {
    // インターバル内である
    isInIntervalFlag = true;

    // そのフレームの有効時間に有効期間を追加して有効期限のケツを弾き出す
    var min = masterSheet.valid_period.replace(/[^0-9]/g, "");
    const frameValidLimit = moment(new Date(used_frames[0].stamped_at)).add(
      min,
      "m"
    );

    // 使用済みのそのフレームの有効期限外なら特別処理
    if (current.isAfter(frameValidLimit)) {
      // 有効期限外かつ、未使用のフレームが無い場合は空を代入
      if (unused_frames.length == 0) {
        console.log("有効期限外かつ、未使用のフレームが無い場合は空を代入");
        frame = {};
      } else {
        // 有効期限外かつ、未使用のフレームがある場合はそれを代入
        console.log("有効期限外かつ、未使用のフレームがある場合はそれを代入");
        frame = unused_frames[0];
      }
    } else {
      // インターバル内なので使用済みのフレーム先頭を代入
      console.log("インターバル内なので使用済みのフレーム先頭を代入");
      frame = used_frames[0];
    }
  }

  return [frame, isInIntervalFlag];
};
